import { AgentStreamEventModel } from '~/models';
const SUPPRESSED_TOOL_NAMES = new Set([
    'submitEnvelope'
]);
const MAX_ACK_TEXT_LENGTH = 500;
export const createAgentStreamParser = ()=>{
    const inFlightTools = new Map();
    return (raw)=>{
        if (raw.data === '[DONE]') return null;
        const data = raw.data ? JSON.parse(raw.data) : {};
        const eventType = data.type;
        const nested = data.data;
        const dto = resolveDto(eventType, nested, raw, data, inFlightTools);
        return dto == null ? null : AgentStreamEventModel.fromDTO(dto);
    };
};
const resolveDto = (eventType, nested, raw, data, inFlightTools)=>{
    switch(eventType){
        case 'data-message':
            return {
                type: 'message',
                message: nested === null || nested === void 0 ? void 0 : nested.message
            };
        case 'data-error':
            return {
                type: 'error',
                error: nested === null || nested === void 0 ? void 0 : nested.error
            };
        case 'data-draft':
            return {
                type: 'draft-created',
                draftId: nested === null || nested === void 0 ? void 0 : nested.draftId
            };
        case 'data-draft-applied':
            return {
                type: 'draft-applied',
                draftId: nested === null || nested === void 0 ? void 0 : nested.draftId
            };
        case 'data-ack':
            {
                const rawText = nested === null || nested === void 0 ? void 0 : nested.text;
                const text = typeof rawText === 'string' ? rawText.slice(0, MAX_ACK_TEXT_LENGTH) : '';
                return {
                    type: 'ack',
                    text
                };
            }
        case 'data-message-enrichment':
            {
                const messageId = nested === null || nested === void 0 ? void 0 : nested.messageId;
                if (messageId == null) return null;
                const contentPatch = resolveContentPatch(nested);
                if (contentPatch == null) return null;
                return {
                    type: 'message-enrichment',
                    messageId,
                    contentPatch
                };
            }
        case 'tool-input-start':
            {
                const toolName = data.toolName;
                if (toolName != null && SUPPRESSED_TOOL_NAMES.has(toolName)) return null;
                return startTool(data.toolCallId, toolName, inFlightTools);
            }
        case 'tool-output-available':
        case 'tool-output-error':
        case 'tool-output-denied':
        case 'tool-input-error':
            return endTool(data.toolCallId, inFlightTools);
        case 'data-reset':
            inFlightTools.clear();
            return {
                type: 'reset'
            };
        case 'data-tool-call':
            return startTool(nested === null || nested === void 0 ? void 0 : nested.toolCallId, nested === null || nested === void 0 ? void 0 : nested.tool, inFlightTools);
        case 'data-read-start':
            return startTool(nested === null || nested === void 0 ? void 0 : nested.readCallId, nested === null || nested === void 0 ? void 0 : nested.fn, inFlightTools);
        case 'data-tool-end':
            return endTool(nested === null || nested === void 0 ? void 0 : nested.toolCallId, inFlightTools);
        case 'data-read-end':
            return endTool(nested === null || nested === void 0 ? void 0 : nested.readCallId, inFlightTools);
        case 'data-analyst-part':
            {
                const toolCallId = nested === null || nested === void 0 ? void 0 : nested.toolCallId;
                const part = nested === null || nested === void 0 ? void 0 : nested.part;
                if (toolCallId == null || part == null) return null;
                return {
                    type: 'analyst-part',
                    toolCallId,
                    part
                };
            }
        case 'start':
        case 'start-step':
        case 'finish-step':
        case 'finish':
        case 'text-start':
        case 'text-delta':
        case 'text-end':
        case 'reasoning-start':
        case 'reasoning-delta':
        case 'reasoning-end':
        case 'tool-input-delta':
        case 'tool-input-available':
        case 'tool-approval-request':
        case 'source':
        case 'message-metadata':
        case 'data-status':
        case 'data-memory-saved':
        case 'data-memory-export':
            return null;
        default:
            // eslint-disable-next-line no-console
            console.warn("unknown SSE event type: ".concat(eventType), {
                raw,
                data
            });
            return null;
    }
};
const startTool = (callId, toolName, inFlightTools)=>{
    if (callId == null || toolName == null) return null;
    inFlightTools.set(callId, {
        toolName,
        startedAt: Date.now()
    });
    return {
        type: 'tool-call-start',
        tool: toolName,
        args: {}
    };
};
const endTool = (callId, inFlightTools)=>{
    if (callId == null) return null;
    const entry = inFlightTools.get(callId);
    if (entry == null) return null;
    inFlightTools.delete(callId);
    return {
        type: 'tool-call-end',
        tool: entry.toolName,
        durationMs: Date.now() - entry.startedAt
    };
};
// WHY: legacy `{ followUp }` fallback covers in-flight agentic frames from the not-yet-upgraded backend during FE-first rollout.
const resolveContentPatch = (nested)=>{
    const contentPatch = nested === null || nested === void 0 ? void 0 : nested.contentPatch;
    if (contentPatch != null) return contentPatch;
    const legacyFollowUp = nested === null || nested === void 0 ? void 0 : nested.followUp;
    if (legacyFollowUp != null) return {
        followUp: legacyFollowUp
    };
    return null;
};
